import React, { useEffect } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/reducers";

const SelectAllBanner = ({
    showSelectAllBanner,
    bannerTempOpenPtr,
    selectAllBannerStyles,
    bannerProcessAllPtr,
    totalCount,
    loading,
    pending,
    name,
    currentPageCount,
    currentPage,
    recordsPerPage,
    totalRecords,
}) => {
    const selectedCount: any = useSelector<RootState>(
        (state) => state.pagesV2[name]?.selected?.length,
    );

    const showProcessAllOption =
        selectedCount > 0 &&
        currentPageCount > 0 &&
        (selectedCount === currentPageCount ||
            (bannerProcessAllPtr?.value &&
                currentPage - 1 >=
                    Math.ceil(totalRecords / recordsPerPage) - 1)) &&
        totalCount > selectedCount;

    useEffect(() => {
        if (pending || loading) return;
        if (!showProcessAllOption && showSelectAllBanner) {
            bannerProcessAllPtr.set(false);
            return;
        }
    }, [showProcessAllOption]);

    return (
        showSelectAllBanner &&
        selectedCount > 0 &&
        bannerTempOpenPtr?.value == true && (
            <Box sx={selectAllBannerStyles}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 400,
                            color: "#6b7280",
                            py: "6px",
                        }}
                    >
                        Total Selected:{" "}
                        {bannerProcessAllPtr?.value == true &&
                        showProcessAllOption ? (
                            totalCount
                        ) : loading || pending ? (
                            <CircularProgress size={10} aria-label="Loading…" />
                        ) : (
                            selectedCount
                        )}
                    </Typography>

                    {!bannerProcessAllPtr?.value && showProcessAllOption && (
                        <Button
                            onClick={() =>
                                bannerProcessAllPtr.set(
                                    !bannerProcessAllPtr?.value,
                                )
                            }
                        >
                            {`Select All ${totalCount}`}
                        </Button>
                    )}
                </Box>
            </Box>
        )
    );
};

export default SelectAllBanner;
